import { AutoMap } from '@automapper/classes';

export class MeasureGenericEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    Name!: string;
    @AutoMap()
    GroupName!: string;
    @AutoMap()
    Reference!: string;
    @AutoMap()
    Observation!: string;
    @AutoMap()
    Number!: number;
    @AutoMap()
    BatchCode!: string;
    @AutoMap()
    IsPrestationAnnexe!: boolean;
}
